import React from 'react';
import NavDatesSelector from './NavDatesSelector';
import NavCollapse from '../../../containers/NavCollapse';
import { isUserAdmin, isUserOwner } from '../../../helpers';
import DeskBookingLink from '../../elements/DeskBookingLink';
import NavToday from '../../elements/NavToday';
import UserSelect from '../../elements/UserSelect';
import type { NavProps } from '../../../types';

const CalendarNavSmallScreen = (props: NavProps): React.ReactElement => {
  const {
    navDates,
    isCalendar,
    currentUser,
    users,
    selectedUser,
    onSelectedUserChange,
    onNavTodayClick,
    onNavPrevWeekClick,
    onNavNextWeekClick,
    onPayrollGeneratorClick,
    onMarketingStatsClick,
    onOpenCheckinModal,
    hasActiveIncidents,
  } = props;
  const isAdmin = isUserAdmin(currentUser);
  const isOwner = isUserOwner(currentUser);

  return (
    <>
      <div className="container-fluid device-small-menu">
        <div className="row">
          <nav className="navbar navbar-default nav-flex-small">
            <div className="today-btn-wrapper">
              <NavToday isCalendar onNavTodayClick={onNavTodayClick} />
              <DeskBookingLink />
            </div>
            <NavDatesSelector
              isCalendar={isCalendar || false}
              navDates={navDates as any}
              onNavPrevWeekClick={onNavPrevWeekClick as any}
              onNavNextWeekClick={onNavNextWeekClick as any}
            />
            <div className="nav-right d-flex align-items-center">
              {(isAdmin || isOwner) && (
                <a href="/incidents" style={{ cursor: 'pointer', marginRight: '8px', textDecoration: 'none' }}>
                  <i className="fa fa-exclamation-triangle"
                     style={{ color: hasActiveIncidents ? '#f0ad4e' : '#ccc', fontSize: '16px' }} />
                </a>
              )}
              {currentUser && currentUser.needsRemoteCheckin && (
                <button
                  type="button"
                  className="btn btn-primary primary-color me-2"
                  onClick={onOpenCheckinModal}
                  style={{ fontSize: '12px', padding: '6px 12px' }}
                >
                  Check In
                </button>
              )}
              <button className="btn menu-bars" type="button" data-toggle="collapse" data-target="#menu" aria-controls="menu" aria-expanded="false" aria-label="Toggle navigation">
                <i className="fa fa-bars fa-2x" aria-hidden="true" />
              </button>
            </div>
          </nav>
        </div>
      </div>
      {isAdmin || isOwner ? (
        <div className="user-select-wrapper">
          <UserSelect
            users={users}
            selectedUser={selectedUser}
            onSelectedUserChange={onSelectedUserChange as any}
          />
        </div>
      ) : null}
      <NavCollapse isAdmin={isAdmin} isOwner={isOwner} selectedUser={selectedUser} onPayrollGeneratorClick={onPayrollGeneratorClick} onMarketingStatsClick={onMarketingStatsClick} />
    </>
  );
};

export default CalendarNavSmallScreen;
